import { render, staticRenderFns } from "./TotalEditContentWrapper.vue?vue&type=template&id=a61e7524&scoped=true"
import script from "./TotalEditContentWrapper.vue?vue&type=script&lang=ts"
export * from "./TotalEditContentWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TotalEditContentWrapper.vue?vue&type=style&index=0&id=a61e7524&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61e7524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a61e7524')) {
      api.createRecord('a61e7524', component.options)
    } else {
      api.reload('a61e7524', component.options)
    }
    module.hot.accept("./TotalEditContentWrapper.vue?vue&type=template&id=a61e7524&scoped=true", function () {
      api.rerender('a61e7524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/TotalEditContentWrapper.vue"
export default component.exports